import { render } from "./OurSustainableApproach.vue?vue&type=template&id=8dfa6eca&ts=true"
import script from "./OurSustainableApproach.vue?vue&type=script&lang=ts"
export * from "./OurSustainableApproach.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__